
<template>
<div class="vehicles-container tabbed-content">
  <chc-loader ref="loader"></chc-loader>
  <datatable
    :source="vehicles"
    :isLoading="isLoading"
    :searchCallback='searchCallback'
    :message="tableMessage">
    <datatable-column
      v-for="(column, index) in columns"
      :id="column.id"
      :label="column.label"
      :labelClass="column.labelClass"
      :key="index"
      :sortKey="column.sort"
      @click="() => {if (column.onClick) {column.onClick()}}">
    </datatable-column>

    <datatable-filter
        id='status_id'
        label='Status'
        :options='status.options'
        :defaultFilter="status.default"
        ref="statusFilter"
        @addFilter="addFilter"
        @removeFilter="removeFilter"
        >
      </datatable-filter>

    <template slot="searchLeft">
      <a v-if="downloadCSV" @click="downloadVehiclesCSV()"><span><i class="far fa-file-excel"></i></span> Download Selected Vehicles (CSV)</a>
      <div class="field">
        <multiselect
          placeholder="Years"
          v-model="years"
          :options="yearOptions"
          :multiple="true"
          :allow-empty="false"
          :hide-selected="false"
          :close-on-select="false"
          @open="() => {yearsOpened = true}"
          @remove="() => {if (!yearsOpened) {
            $nextTick(() => {
              refresh(currentSearch)
            })
          }}"
          @close="() => {
            yearsOpened = false
            refresh(currentSearch)
          }"
        ></multiselect>
      </div>
    </template>

    <template slot="source_template" slot-scope="data">
      <tr>
        <td class="table-checkbox" v-if="downloadCSV"><chc-checkbox v-model="data.row.download"></chc-checkbox></td>
        <td @click="gotoRow(data.row.id)">{{ data.row.ref_number }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.actual_tow_date }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.donor_name }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.year_make_model }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.sale_price }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.adj_gross_proceeds }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.charity_proceeds }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.charity_paid }}</td>
        <td @click="gotoRow(data.row.id)">{{ data.row.status }}</td>
      </tr>
    </template>

    <template slot="tfoot" slot-scope="data">
      <tr>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td></td>
        <td>TOTAL PROCEEDS</td>
        <td>{{ total_proceeds }}</td>
        <td></td>
        <td></td>
      </tr>
    </template>
  </datatable>
</div>
</template>

<script>
import Datatable from '@/components/Datatables/AppDatatable'
import DatatableColumn from '@/components/Datatables/AppDatatableColumn'
import DatatableFilter from '@/components/Datatables/AppDatatableFilter'
import store from '@/store'
import helpers from '@/helpers'

import Multiselect from 'vue-multiselect'

export default {
  name: 'CharityVehicles',
  props: {
    charityId: {},
    downloadCSV: {
      type: Boolean,
      default: false
    }
  },
  mounted () {
    Promise.all([
      store.functions.charity.getVehicleYears(this.charityId, (response) => { this.yearOptions = response.data }),
      store.functions.charity.getVehicles(this.charityId, null, (response) => {
        this.vehicles = response.data.table_data
        this.total_proceeds = response.data.total_proceeds
        this.status.options = Object.values(response.data.status_filter)
        this.status.default = Object.values(response.data.initial_filter)
        this.filters = Object.values(response.data.initial_filter)
        this.$nextTick(() => {
          this.$refs.statusFilter.init()
        })
      }, JSON.stringify(this.filters), JSON.stringify(this.years))
    ]).then(response => {
    }).finally(() => {
      this.isLoading = false
    })
  },
  data () {
    let now = new Date()
    return {
      loadingVehiclePage: false,
      isLoading: true,
      vehicles: [],
      total_proceeds: 0,

      tableMessage: null,

      status: {
        id: 'status',
        label: 'Status',
        options: [],
        default: []
      },
      filters: [
        'Complete',
        'Pending Paperwork',
        'Sold - Pending Remittance',
        'Sold - Pending Payment',
        'Pending Sale',
      ],

      currentSearch: null,

      yearsOpened: false,
      years: [now.getFullYear()],
      yearOptions: [now.getFullYear()],

      allSelected: false,
    }
  },
  computed: {
    columns () {
      let columns = [
        { id: 'ref_number', label: 'Ref #' },
        { id: 'actual_tow_date', label: 'Tow Date', sort: 'tow_date_sort' },
        { id: 'donor_name', label: 'Donor Name' },
        { id: 'year_make_model', label: 'Year/Make/Model' },
        { id: 'sale_price', label: 'Sale Price' },
        { id: 'adj_gross_proceeds', label: 'Adj. Gross Proceeds' },
        { id: 'charity_proceeds', label: 'Charity Proceeds' },
        { id: 'charity_paid', label: 'Charity Paid' },
      ]
      if (this.downloadCSV) {
        var self = this
        columns.unshift({
          id: 'download',
          label: ' ',
          labelClass: 'fas fa-check',
          onClick: () => {
            self.allSelected = !self.allSelected
            for (var i = self.vehicles.length - 1; i >= 0; i--) {
              self.vehicles[i].download = self.allSelected
            }
          }
        })
      }
      return columns
    },
    downloadVehiclesIds () {
      let ids = []
      for (var i = this.vehicles.length - 1; i >= 0; i--) {
        if (this.vehicles[i].download) ids.push(this.vehicles[i].id)
      }
      if (ids.length > 0) return ids
      return []
    }
  },
  components: {
    Datatable,
    DatatableColumn,
    DatatableFilter,
    Multiselect,
  },
  methods: {
    setYears (years) {
      this.yearOptions = years
    },
    onClick () {
      console.log('clickl')
    },
    refresh (filter = null) {
      if (this.isLoading) return
      this.isLoading = true
      store.functions.charity.getVehicles(this.charityId, filter, (response) => {
        this.tableMessage = null
        this.vehicles = response.data.table_data
        this.total_proceeds = response.data.total_proceeds
        this.status.options = Object.values(response.data.status_filter)
        this.status.default = Object.values(response.data.initial_filter)
        this.filters = Object.values(response.data.initial_filter)
        this.isLoading = false
      }, JSON.stringify(this.filters), JSON.stringify(this.years)).catch(err => {
        console.log(err)
        this.vehicles = []
        this.tableMessage = 'Request to large to load, please reduce the number of years selected'
        this.isLoading = false
        this.total_proceeds = null
      })
    },
    addFilter (option) {
      let index = this.filters.indexOf(option)
      if (index === -1) {
        this.filters.push(option)
      }
      this.refresh()
    },
    removeFilter (option) {
      let index = this.filters.indexOf(option)
      if (index !== -1) {
        this.filters.splice(index, 1)
      }
      this.refresh()
    },
    searchCallback (filter) {
      this.currentSearch = filter
      this.refresh(filter)
    },
    gotoRow (rowId) {
      // if (this.downloadCSV) return
      this.$refs.loader.show()
      this.$router.push({name: 'Vehicle', params: {vehicleId: rowId}}, () => {
        this.$refs.loader.hide()
      })
    },
    downloadVehiclesCSV () {
      if (!this.downloadCSV) return
      store.functions.charity.downloadVehiclesCSV({ids: JSON.stringify(this.downloadVehiclesIds)})
        .catch((error) => console.log(error))
        .then((response) => {
          helpers.openAsDownload(response.data, 'charity_vehicles_' + (new Date()).toJSON() + '.csv')
        })
    },
  }
}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style lang="scss" scoped>
@import "../../style/variables";

td.table-checkbox, td.table-checkbox * {
    width: 25px;
  }

th.table-checkbox, th.table-checkbox * {
  width: 25px;
}

:not(.fixed) .field-label {
    cursor: text;
}

#caret-down {
    position: absolute;
    top: .25rem;
    right: .25rem;
}

#loader {
    position: absolute;
    top: 25%;
    right: 50%;
    color: $lt-grey;
}

.multiselect__input {
    height: 2rem;
}

.multiselect__content-wrapper {
    position: absolute;
    top: 1.7rem;
    right: 0;
    background-color: #ffffff;
    /* border-top: 2px solid $yellow; */
    border-radius: 0 0 .25rem .25rem;
    box-shadow: 0 3px 10px $dark-grey;
    padding: 0;
    list-style-type: none;
    margin: 0;
    width: 100%;
    z-index: 100;
    text-align: left;
    &:before {
        content: '';
        display: block;
        height: 3px;
        position: absolute;
        top: -5px;
        width: 100%;
        left: -1px;
    }
    li {
        margin: 0;
        padding: .50rem;
        display: block;
        &:hover {
            background: $light-blue;
        }
    }
}

.index-heading > * {
  margin: 1rem;
}

</style>



// WEBPACK FOOTER //
// src/components/Charity/CharityVehicles.vue